import { BenchmarkDetail } from '@/components/benchmark';
import { Callout } from '@/components/investor';
import { CUDA, MLX } from '@/content/benchmarks';

export function MlxBenchmarkPage() {
  return (
    <BenchmarkDetail
      platform={MLX}
      other={CUDA}
      e2eExtra={
        <Callout title="Why a second accelerator family">
          Corroboration, not addition. Apple Silicon runs a different model, runtime and memory architecture from the NVIDIA result, so the two are never
          compared on the numbers. What repeats is the direction: the framework makes the backend lighter, and the throughput and latency gains appear once
          the capacity contract continues into the engine. It is also the low-cost edge and development path.
        </Callout>
      }
    />
  );
}
